module.exports = __webpack_public_path__ + "static/media/1.3.1142b386.png";